<template>
  <div v-if="permanentCategory" class="sf-title sf-below-2">
    <span>
      <a
        v-dompurify-html="parentCategoryTitle"
        class="sf-a"
        @click="navigateFunction(navigateParams)"
      />
    </span>

    <span class="sf-breadcrumb-divider" />
    <span v-dompurify-html="permanentCategory.title" />
  </div>
</template>

<script>
export default {
  name: 'DocumentBreadcrumbs',
  props: [
    'parentCategory',
    'permanentCategory',
    'navigateFunction',
    'navigateParams',
  ],
  computed: {
    parentCategoryTitle() {
      return this.parentCategory
        ? this.parentCategory.title
        : I18n.t('permanent_document.modal_select.documents')
    },
  },
}
</script>
